const packageName = process.env._PACKAGE_NAME_ as string;
const packageVersion = process.env._PACKAGE_VERSION_ as string;

const _default_1: {
    packageName: string;
    packageVersion: string;
} = {
    packageName,
    packageVersion,
};
export default _default_1;
